import "./errorPage.css"
import React from 'react'
import Lottie from "lottie-react";
import ErrorCode from "../../assets/lottie/ErrorCode.json"
import { Link } from 'react-router-dom';

export function classifyNumber(num) {
  if (num > 0) {
    return "Positive";
  } else if (num === 0) {
    return "Zero";
  } else {
    return "Negative";
  }
}
 
export function NumberClassifier({ number }) {
  const result = classifyNumber(number);
  return <div>{`The number is ${result}`}</div>;
}
const ErrorPage = () => {
  return (
    <div className='error-margin-left'>
    <div className="errorPage" >
      <Lottie animationData={ErrorCode} />
    <div className="error_Back_Btn_Cont">  <Link className='ErrorBtn' to={"/main"}>Back to Dashboard</Link></div>
    </div>
  </div>  )
}

export default ErrorPage